import { getGroupList } from '../../api/auth'

const state = {
  groups: [], // 角色列表
}
const getters = {
  groups: (state) => state.groups,
}
const mutations = {
  setGroups(state, groups) {
    state.groups = groups
  },
}
const actions = {
  async getgroups({ commit }) {
    const { data } = await getGroupList()
    commit('setGroups', data)
  },
}
export default { state, getters, mutations, actions }
